/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { AutosaveManager } from '@trebox-studio/autosave';

import {
  usePersonaStore,
  type PersonaStore,
  type RequiredBotPrompt,
} from '@/store/persona';
import { type ItemType } from '@/save-manager/types';

import { saveRequest } from '../request';
import { personaConfig } from './config';

export const personaSaveManager = new AutosaveManager<
  PersonaStore,
  ItemType,
  RequiredBotPrompt
>({
  store: usePersonaStore,
  registers: [personaConfig],
  saveRequest,
});
